<template>
  <div class="staticip-main">
    <div class="staticip-top">
      <el-form ref="form" :model="form" label-position="left" class="mgr-operations" :inline="true">
        <el-form-item>
          <el-input v-model="form.searchKey" :placeholder="$t('ipmgr.form.order_no_placeholder')"></el-input>
        </el-form-item>
        <el-form-item>
          <div class="ip-input-group">
            <el-input 
              v-model="form.ip" 
              :placeholder="importedIps.length > 0 ? $t('ipmgr.form.n_ips_imported', {numIps: importedIps.length}): $t('ipmgr.form.ip_placeholder')"
              :disabled="showImportButton"
              @input="handleIpInput">
              <i 
                v-if="importedIps.length > 0" 
                slot="suffix" 
                class="el-input__icon el-icon-close clear-import-btn"
                @click="clearImportedIps" :title="$t('ipmgr.form.clear_ips')">
              </i>
            </el-input>
            <el-button 
              @click="handleCheckIps" 
              v-cloak 
              :disabled="!showImportButton && form.ip.trim() !== ''"
              class="import-btn">
              {{ $t("ipmgr.form.check_ips")}}
            </el-button>
          </div>
        </el-form-item>
        <el-form-item>
          <el-select v-model="form.selectedStatus" :placeholder="$t('ipmgr.form.state_placeholder')">
            <el-option v-for="(item, key) in statusOptions" :key="key" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="form.selectedTag" :placeholder="$t('ipmgr.tag_form.tag_placeholder')" filterable>
            <el-option v-for="(item, key) in tagFilter" :key="key" :label="item.tag" :value="item.tag">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="handleSearch" v-cloak>{{ $t('ipmgr.form.search') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button :disabled="selection_list.length==0" @click="handleExportIps" v-loading="exporting" v-cloak>{{ $t('ipmgr.form.export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button :disabled="!can_renew" @click="handleRenewIps" v-cloak>{{ $t('ipmgr.form.renew') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button :disabled="selection_list.length==0" @click="handleCopyIps" v-loading="coping" v-cloak>{{ $t('ipmgr.form.copy') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button :disabled="selection_list.length==0" @click="handleTagIps" v-loading="taging" v-cloak>{{ $t('ipmgr.form.tag') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="staticip-center">
      <div class="list-table">
        <el-table ref="multipleTable" :row-key="(row) => row.id" :data="tableData" :cell-class-name="tableCellClassName" v-loading="searching"
          element-loading-text="Loading" height="100%" style="width: 100%; overflow-y: scroll;"
          @sort-change="changeSortDir" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" header-align="center" align="center"
            :reserve-selection="true"
            :selectable="isRowSelectable">
          </el-table-column>
          <el-table-column prop="ip" :label="tableName[0]" header-align="center" align="center">
            <template slot="header" slot-scope="scope">
              <span>{{ tableName[0] }}</span>
              <el-tooltip class="item" effect="dark" :content="$t('ipmgr.form.export_tips')" placement="top-start">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="country" :label="tableName[2]" header-align="center" align="center">
          </el-table-column>
          <el-table-column prop="timeLength_table" :label="tableName[3]" header-align="center" align="center" width="60">
          </el-table-column>
          <el-table-column prop="create_time" :label="tableName[4]" sortable="custom" header-align="center" align="center" width="200">
          </el-table-column>
          <el-table-column prop="expire_time" :label="tableName[5]" sortable="custom" header-align="center"
            align="center" width="200">
          </el-table-column>
          <el-table-column prop="status" :label="tableName[6]" header-align="center" align="center" width="80">
          </el-table-column>
          <el-table-column prop="tag" :label="tableName[7]" sortable="custom" header-align="center" align="center">
          </el-table-column>
          <el-table-column prop="order_no" header-align="center" align="center">
            <template v-slot:header="scope">
              <span>{{ tableName[1] }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="tableName[8]" header-align="center" align="center">
            <template slot-scope="scope">
              <el-button class="operate" size="mini" type="text" @click="doCopySingleIp(scope.row)">{{ scope.row.copy_table }}</el-button>
              <el-button v-if="scope.row.renew_table !== ''" class="operate" size="mini" type="text" @click="toRenewSingleIp(scope.row)">{{ scope.row.renew_table }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination 
          v-if="showPagination"
          class="isp-page" 
          layout="total, prev, pager, next, sizes"
          @current-change="handlePageChange"
          :current-page.sync="curPage" 
          :page-size="paginationSize" 
          :size="paginationSize" 
          :total="paginationTotal"
          @size-change="handleSizeChange" 
          :page-sizes="$store.state.userPreferences?.paginationSizes || [10, 20, 50, 100]" 
          small>
        </el-pagination>
      </div>
    </div>

    <el-dialog width="80%" class="renew-bulk" :title="$t('ipmgr.renew_form.title')" :visible.sync="renew_dialog_visible"
      :close-on-click-modal=false :center=true :before-close="handleRenewDialogClose" v-loading="dialog_loading">
      <div class="renew-bulk-center">
        <div class="ips-list">
          <div class="ip-div" v-for="(item, index) in selection_list" :key="index" v-cloak>
            <span class="ip">{{ item.ip }}</span>
            <i class="el-icon-remove-outline" @click="cancelRenewIp(item)"></i>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-b" @click="toRenew()" v-cloak>{{ $t('ipmgr.renew_form.renew') }}</el-button>
        <el-button class="btn-w" @click="renew_dialog_visible = false;" v-cloak>{{ $t('ipmgr.renew_form.close') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog width="80%" class="tag-bulk" :title="$t('ipmgr.tag_form.title')" :visible.sync="tag_dialog_visible"
      :close-on-click-modal=false :center=true :before-close="handleTagDialogClose" v-loading="dialog_loading" @opened="loadTagOptions">
      <div class="tag-bulk-center">
        <div class="form-line">
          <div class="tag">{{ $t('ipmgr.tag_form.tag_label') }}</div>
          <el-select v-model="form.selectedTag" :placeholder="$t('ipmgr.tag_form.tag_placeholder')" filterable allow-create>
            <el-option v-for="(item, key) in tagOptions" :key="key" :label="item.tag" :value="item.tag">
            </el-option>
          </el-select>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-b" @click="doTagIps()" v-cloak>{{ $t('ipmgr.tag_form.tag') }}</el-button>
        <el-button class="btn-w" @click="tag_dialog_visible = false;" v-cloak>{{ $t('ipmgr.tag_form.close') }}</el-button>
      </div>
    </el-dialog>

    <!-- 导入IP对话框 -->
    <ImportIPDialog 
      ref="importIPDialog"
      :placeholder="$t('ipmgr.form.check_ips_placeholder')"
      @confirm="handleImportIpsConfirm">
    </ImportIPDialog>

  </div>
</template>

<script>
import clipboard from "clipboard";
import { getStaticIpList, getStaticIpsByIpList, exportStaticIps, extractProxyAccounts, tagIps } from '@/http/api/order'
import { utcTimestampToLocalTime } from '@/util/human'
import { getUserTags } from "@/http/api/member";
import ImportIPDialog from '@/components/ImportIPDialog.vue'

export default {
  name: 'staticisp-orders',
  components: {
    ImportIPDialog
  },

  data() {
    return {
      searching: false,
      exporting: false,
      coping: false,
      taging: false,
      showImportButton: false,
      
      form: {
        searchKey: '',
        ip: '',
        selectedStatus: 0,
        selectedTag: this.$t('ipmgr.form.state.all'),
      },
      
      sort_field: '',
      tableData: [],
      paginationTotal: 0,
      curPage: 1,
      operating_id_arr: '',
      operating_num: 0,
      can_renew: true,
      renew_dialog_visible: false,
      tag_dialog_visible: false,
      selection_list: [],
      dialog_loading: false,

      tagOptions: [], // user tag options
      importedIps: [], // 存储导入的IP列表
      lastImportedContent: '' // 存储上一次导入的IP内容
    }
  },
  inject: ['updateCurrentMenuUrl'],
  computed: {
    statusOptions() {
      return [
        { label: this.$t('ipmgr.form.state.all'), value: 0 },
        { label: this.$t('ipmgr.form.state.opening'), value: 1 },
        { label: this.$t('ipmgr.form.state.normal'), value: 2 },
        { label: this.$t('ipmgr.form.state.expired'), value: 3 }
      ]
    },

    tableName() {
      return this.$t('ipmgr.table_name')
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    paginationSize() {
      return this.$store.state.userPreferences?.paginationSize || 10;
    },
    tagFilter() {
      return [{ key: '-1', tag: this.$t('ipmgr.form.state.all') }, ...this.tagOptions];
    },
    showPagination() {
      // 当导入IP时（tableData长度等于paginationTotal且大于分页大小）隐藏分页
      return !(this.tableData.length === this.paginationTotal && this.tableData.length > this.paginationSize);
    }
  },
  watch: {
  },
  created() {
    this.updateCurrentMenuUrl('/ucenter/staticisp/ips');
  },
  mounted() {
    if (this.isLogin) {
      var par = this.getRequestParams()
      if(par.orderNo){
          this.form.searchKey = par.orderNo
      }
      this.loadTagOptions()
      this.getIpList(1)
    } else {
      location.href = '/login/'
    }
  },
  
  methods: {
    handleSearch: function () {
      this.getIpList(1)
    },
    handleExportIps: function () {
      let self = this
      if (self.selection_list.length > 0) {
        let idarr = []
        for (let i = 0; i < this.selection_list.length; i++) {
          idarr.push(this.selection_list[i].id)
        }
        self.exporting = true;

        let data={ 
          ip_ids: idarr.toString(),
          sortField:self.sort_field,
        }
        exportStaticIps(data).then(res => {
          let blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }); //res.data--File stream returned in the background
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.setAttribute('download', 'IP_List.xlsx');
          link.download = "IP_List.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch(e => {
          // self.$message.error(e.message ?? e.msg ?? "export static house ips error");
        }).finally(() => {
          self.exporting = false;
        })
      }
    },
    handleRenewIps: function () {
      let self = this
      if (self.operating_num > 0) {
        if (self.can_renew) {
          this.renew_dialog_visible = true;
          this.dialog_loading = true;
          self.selection_list.some(key => {
            self.tableData.some(row => {
              if (row.id == key.id) {
                self.$refs.multipleTable.toggleRowSelection(row, false);
                self.$refs.multipleTable.toggleRowSelection(row, true);
              }
            })
          })
          this.dialog_loading = false;
        } else {
          self.$message({
              message: this.$t('ipmgr.message.cannot_renew'),
              type: 'warning',
            })
        }
      }
    },
    handleCopyIps: function () {
      let self = this
      if (self.selection_list.length > 0) {
        let idarr = []
        for (let i = 0; i < this.selection_list.length; i++) {
          idarr.push(this.selection_list[i].id)
        }

        self.coping = true;

        let data={ 
          ip_ids: idarr.toString(),
        }
        extractProxyAccounts(data).then(res => {
          let accounts = res.data.accounts
          clipboard.copy(accounts.join('\n'))
          self.$message({
              message: this.$t('ipmgr.message.copied'),
              type: 'success',
            })
        })
        .catch(e => {
          // self.$message.error(e.message ?? e.msg ?? "export static house ips error");
        }).finally(() => {
          self.coping = false;
        })
      }
    },
    
    handleTagIps: function() {
      let self = this
      if (self.operating_num > 0) {
        self.tag_dialog_visible = true;
        self.dialog_loading = true;
        self.selection_list.some(key => {
          self.tableData.some(row => {
            if (row.id == key.id) {
              self.$refs.multipleTable.toggleRowSelection(row, false);
              self.$refs.multipleTable.toggleRowSelection(row, true);
            }
          })
        })
        self.dialog_loading = false;
      }
    },
    async loadTagOptions() {
      const { data = [] } = await getUserTags();
      this.tagOptions = data;
    },
    doTagIps: function() {
      let self = this
      if (self.selection_list.length > 0) {
        let idarr = []
        for (let i = 0; i < this.selection_list.length; i++) {
          idarr.push(this.selection_list[i].id)
        }

        self.taging = true;

        let data={ 
          ip_ids: idarr.toString(),
          tag: self.form.selectedTag,
        }
        tagIps(data).then(res => {
          self.tag_dialog_visible = false;
          self.resetSelections();

          self.$message({
              message: this.$t('ipmgr.message.tags_success'),
              type: 'success',
            });
  
          self.getIpList(self.curPage);
        })
        .catch(e => {
          // self.$message.error(e.message ?? e.msg ?? "export static house ips error");
        }).finally(() => {
          self.taging = false;
        })
      }
    },

    handleTagDialogClose() {
      this.tag_dialog_visible = false;
      this.resetSelections();
    },

    updateSelected() {
      if (this.selection_list.length > 0) {
        let idarr = []
        let longid = ''
        let num = this.selection_list.length
        let no_normal_num = 0;
        for (let i = 0; i < this.selection_list.length; i++) {
          idarr.push(this.selection_list[i].id)

          // 只判断续费状态
          if (this.selection_list[i].status !== this.$t('ipmgr.state.normal') && 
              !(this.selection_list[i].status === this.$t('ipmgr.state.expired') && this.selection_list[i].extime >= -4)) {
            no_normal_num++;
          }
        }
        if (no_normal_num > 0) {
          this.can_renew = false;
        } else {
          this.can_renew = true;
        }
        longid = idarr.toString()
        this.operating_id_arr = longid;
        this.operating_num = num;
      } else {
        this.selection_list = [];
        this.operating_id_arr = ""
        this.operating_num = 0;
        this.can_renew = true;
      }
    },

    resetSelections() {
      this.operating_id_arr = ""
      this.operating_num = 0;
      this.selection_list = [];
      this.$refs.multipleTable.clearSelection();
    },

    handleRenewDialogClose() {
      let title = this.$t('ipmgr.confirm.title')
      let describe = this.$t('ipmgr.confirm.describe')
      let btn1 = this.$t('ipmgr.confirm.confirm')
      let btn2 = this.$t('ipmgr.confirm.close')
      
      this.$confirm(describe, title, {
        confirmButtonText: btn1,
        cancelButtonText: btn2,
        type: 'warning'
      }).then(() => {
        this.renew_dialog_visible = false;
        this.can_renew = true;
        this.resetSelections()
      }).catch(() => {
        this.renew_dialog_visible = false;
      });
    },

    cancelRenewIp: function (val) {
      let title = this.$t('ipmgr.confirm_delete.title')
      let describe = this.$t('ipmgr.confirm_delete.describe', {ip: val.ip})
      let btn1 = this.$t('ipmgr.confirm_delete.yes')
      let btn2 = this.$t('ipmgr.confirm_delete.no')

      this.$confirm(describe, title, {
        confirmButtonText: btn1,
        cancelButtonText: btn2,
        type: 'warning'
      }).then(() => {
        this.$refs.multipleTable.toggleRowSelection(val, false);
        if (this.selection_list.length <= 0) {
          this.resetSelections();
        }
      }).catch((e) => {
        // this.$message.error(e.message ?? e.msg ?? "cancel ip error");
      })
    },

    toRenew() {
      this.updateSelected();
      if (this.can_renew) {
        let item = {
          type: 2,
          renew_ip_ids: this.operating_id_arr,
          renew_type: 'renew',
          num: this.operating_num,
        }
        this.$router.push({ path: '/payment', query: item, redirect: '/ucenter/staticisp' })
      } else {
        self.$message({
          message: this.$t('ipmgr.message.cannot_renew'),
          type: 'warning',
        })
      }
    },

    handleSelectionChange(selection) {
      let self = this;
      // 过滤掉不可选的行
      self.selection_list = selection.filter(row => this.isRowSelectable(row));
      self.updateSelected();
    },

    doCopySingleIp: function (row) {
      let self = this
      
      let idarr = [row.id]
      self.coping = true;

      let data={ 
        ip_ids: idarr.toString(),
      }
      extractProxyAccounts(data).then(res => {
        let accounts = res.data.accounts
        clipboard.copy(accounts.join('\n'))
        self.$message({
            message: this.$t('ipmgr.message.copied'),
            type: 'success',
          })
      })
      .catch(e => {
        // self.$message.error(e.message ?? e.msg ?? "export static house ips error");
      }).finally(() => {
        self.coping = false;
      })
    },

    toRenewSingleIp: function (row) {
      let self = this
      if (row.status !== self.$t('ipmgr.state.normal') && !(row.status === this.$t('ipmgr.state.expired') && row.extime >= -4)) {
        self.$message({
              message: this.$t('ipmgr.message.cannot_renew'),
              type: 'warning',
            })
      } else {
        let id = "" + row.id
        let num = 1
        let item = {
          type: 2,
          renew_ip_ids: id,
          renew_type: 'renew',
          num: num,
        }
        this.$router.push({ path: '/payment', query: item})
      }
    },

    getIpList: function (page) {
      this.searching = true;

      let self = this
      var size = self.paginationSize;
      if (typeof (page) == 'undefined') {
        page = 1;
      }
      self.curPage = page
      self.tableData = []

      let param = {
        page: page,
        limit: size,
        orderNo: self.form.searchKey,
        ip: self.form.ip,
        ips: self.importedIps,
        status: self.form.selectedStatus,
        tag: self.form.selectedTag === this.$t('ipmgr.form.state.all') ? '' : self.form.selectedTag,
        sortField: self.sort_field,
      }
      getStaticIpList(param).then(res => {
          self.paginationTotal = res.data.total
          self.tableData = []
          let list = res.data.list || [];
          // 1-开通中 2-正常 3-已过期 4-已释放 5-已禁用
          // 将数字状态码映射到对应的翻译字符串，提高可读性
          const statusMap = {
            "5": self.$t('ipmgr.state.disabled'), // 已禁用
            "2": self.$t('ipmgr.state.normal'),   // 正常
            "1": self.$t('ipmgr.state.opening'),  // 开通中
            "0": self.$t('ipmgr.state.opening'),  // 开通中
          };
          for (let i = 0; i < list.length; i++) {
            list[i].extime = ((list[i]['expire_time'] - Math.round(new Date() / 1000)) / (24 * 60 * 60)).toFixed(0)
            if (list[i].extime >= 1) {
              list[i].timeLength = parseInt((list[i]['expire_time'] - Math.round(new Date() / 1000)) / (24 * 60 * 60))
            } else if (list[i].extime <= 0) {
              list[i].timeLength = 0
            } else {
              list[i].timeLength = 1
            }
            
            list[i].timeLength_table = list[i].timeLength + ' ' + self.$t('ipmgr.days');
            
            // 根据状态码获取对应的翻译字符串，如果不在映射中则默认为"已过期"
            list[i].status = statusMap[list[i]['status']] || self.$t('ipmgr.state.expired');
            list[i]['create_time'] = utcTimestampToLocalTime(list[i]['create_time']*1000, 1)
            list[i]['expire_time'] = utcTimestampToLocalTime(list[i]['expire_time']*1000, 1)

            // 如果状态是正常或者已过期不超过4天，则显示续费按钮
            if (list[i].status == self.$t('ipmgr.state.normal') || 
              (list[i].status == self.$t('ipmgr.state.expired') && list[i].extime >= -4)) {
              list[i].renew_table = self.$t('ipmgr.renew')
            } else {
              list[i].renew_table = ''
            }
            list[i].copy_table = self.$t('ipmgr.form.copy')
            self.tableData.push(list[i])
          }
      }).catch(e => {
        // self.$message.error(e.message ?? e.msg ?? "get static ip list error");
      }).finally(() => {
        self.searching = false
      });
    },
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      if (row.status !== this.$t('ipmgr.state.normal') && 
          row.status !== this.$t('ipmgr.state.opening') &&  
          !(row.status === this.$t('ipmgr.state.expired') && row.extime >= -4)) {
        return 'disabled-renew-row';
      }
    },
    handleSizeChange(val) {
      if (this.isLogin) {
        this.$store.commit('updateUserPreference', { paginationSize: val });
        this.getIpList(1)
      } else {
        gotoLogin();
      }
    },
    handlePageChange: function () {
      if (this.isLogin) {
        this.getIpList(this.curPage)
      } else {
        gotoLogin();
      }
    },
    changeSortDir: function ({ column }) {
      var sort = column.order
      var property = column.property
    
      if (sort == "ascending") {
        this.sort_field = property + ' ASC'
      } else if (sort == "descending") {
        this.sort_field = property + ' DESC'
      }
      this.getIpList(1)
    },
    getRequestParams: function () {
      var url = location.search; //Get the string of "?"
      var theRequest = new Array();
      if (url.indexOf("?") != -1) {
        var strs = url.substr(1).split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1]);
        }
      }
      return theRequest;
    },
    isRowSelectable(row) {
      return true;
    },
    handleCheckIps() {
      this.showImportButton = true;
      this.form.ip = '';
    
      this.$refs.importIPDialog.setContent(this.lastImportedContent);
      this.$refs.importIPDialog.showDialog();
    },

    handleImportIpsConfirm(ipContent) {
      if (!ipContent || ipContent.trim() === '') {
        this.$message.warning(this.$t('ipmgr.message.empty_ips'));
        return;
      }

      // 保存导入的IP内容，供下次导入时使用
      this.lastImportedContent = ipContent;
      
      // 解析IP内容，支持多种格式
      const ipList = this.parseIpContent(ipContent);
      
      if (ipList.length === 0) {
        this.$message.warning(this.$t('ipmgr.message.invalid_ips'));
        return;
      }
      this.importedIps = ipList;

      this.$refs.importIPDialog.closeDialog();
    },

    parseIpContent(content) {
      const lines = content.split('\n');
      const ipList = [];
      
      for (const line of lines) {
        const trimmedLine = line.trim();
        if (trimmedLine) {
          // 支持多种格式：纯IP、IP:PORT、IP:PORT:USER:PASS
          const parts = trimmedLine.split(':');
          if (parts.length >= 1) {
            const ip = parts[0].trim();
            // 简单的IP格式验证
            if (this.isValidIp(ip)) {
              ipList.push(ip);
            }
          }
        }
      }
      
      return ipList;
    },

    isValidIp(ip) {
      // 简单的IP格式验证
      const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      return ipRegex.test(ip);
    },


    handleIpInput(value) {
      this.showImportButton = false;
      // 当用户手动输入时，清空导入的IP列表
      if (value.trim() !== '') {
        this.importedIps = [];
      }
    },

    clearImportedIps() {
      // 清空导入的IP列表
      this.importedIps = [];
      // 清空上一次导入的内容
      this.lastImportedContent = '';
      // 重新加载原始数据
      this.getIpList(1);
      // 重置表单
      this.form.ip = '';
      this.showImportButton = false;
    },
  }
}

</script>

<style scoped lang="scss">

::v-deep .el-loading-mask {
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .el-loading-spinner {
  margin: 0;
  width: fit-content;
}

::v-deep .el-tooltip img {
    display: inline-block;
}

$background-color: #f0f2f9;
$button-bg-color-primary: #276dfd;
$button-bg-color-secondary: rgba(39, 109, 253, 0.2);
$button-text-color: #fff;
$font-family: "Poppins-Medium";
$font-size: 16px;
$placeholder-color: rgba(204, 204, 204, 0.6);
$text-color: #11182e;
$border-radius: 10px;
$header-bg-color: #dce4fa;
$row-bg-color-odd: #fcfcfe;
$row-bg-color-even: #f0f2f9;
$cell-font-family: "Poppins-Medium";
$cell-font-size: 14px;
$header-font-size: 16px;
$cell-color: rgba(17, 24, 46, 0.6);
$header-color: #11182e;
$border-radius: 10px;

// 新增表格禁用行相关变量
$table-disabled-bg: #f5f7fa;
$table-disabled-text: #b0b4ba;

.staticip-main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  & .staticip-top {
    & .mgr-operations {
      > .el-form-item {
        width: 100%;
        max-width: 163px;
        height: 56px;
        background-color: $background-color;
        border-radius: $border-radius;

        &:nth-of-type(n+2) {
          max-width: 243px;
        }
        &:nth-of-type(n+3) {
          max-width: 123px;
        }
        &:nth-of-type(n+4) {
          max-width: 163px;
        }

        &:nth-of-type(n+5) {
          max-width: 163px;

          & .el-button {
            border-radius: $border-radius;
            background-color: $button-bg-color-primary;
            color: $button-text-color;
          }
        }

        &:nth-of-type(n+6) {
          width: auto;
          max-width: auto;

          & .el-button {
            background-color: $button-bg-color-secondary;
            color: $button-bg-color-primary;
          }
        }

        ::v-deep .el-form-item__content {
          width: 100%;
          height: 100%;

          .el-input,
          .el-select,
          .el-button {
            width: 100%;
            height: 100%;
            font-family: $font-family;
            font-size: $font-size;

            &__inner {
              width: 100%;
              height: 100%;
              border: none;
              outline: none;
              font-family: $font-family;
              font-size: $font-size;
              color: $text-color;
              background-color: $background-color;
              border-radius: $border-radius;
            }

            input::placeholder {
              font-family: $font-family;
              font-size: $font-size;
              color: $placeholder-color;
            }

            &:focus {
              outline: none;
            }
          }
        }
      }
    }
  }

  & .staticip-center {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;

    & .list-table {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-height: 0;
      padding-bottom: 60px; // 为分页组件预留空间

      ::v-deep .el-table {
        flex: 1;
        overflow: auto;

        &::before {
          height: 0px;
        }

        &__body-wrapper {
          border-radius: 0 0 $border-radius $border-radius;
        }

        &__header {
          thead {
            width: 100%;
            height: 56px;
            background-color: $header-bg-color;
            border-radius: $border-radius $border-radius 0 0;

            tr {
              height: 56px;
              background-color: $header-bg-color;

              th.el-table__cell {
                height: 56px;
                background-color: $header-bg-color;

                .cell {
                  font-family: $cell-font-family;
                  font-size: $header-font-size;
                  font-weight: normal;
                  font-stretch: normal;
                  letter-spacing: 0;
                  color: $header-color;
                }

                &:first-of-type {
                  border-radius: $border-radius 0 0 0;
                }

                &:nth-of-type(10) {
                  border-radius: 0 $border-radius 0 0;
                }
              }
            }
          }
        }

        &__body {
          tbody {
            tr.el-table__row {
              td.el-table__cell {
                height: 56px;

                .cell {
                  font-family: $cell-font-family;
                  font-size: $cell-font-size;
                  font-weight: normal;
                  font-stretch: normal;
                  letter-spacing: 0;
                  color: $cell-color;

                  .operate {
                    font-family: $cell-font-family;
                    font-size: $header-font-size;
                  }
                }
              }

              &:nth-child(odd) {
                background-color: $row-bg-color-odd;
              }

              &:nth-child(even) {
                background-color: $row-bg-color-even;
              }
            }
          }
        }
      }

      .el-pagination {
        padding: 10px 0;
        text-align: center;
      }
    }
  }
}

.popup-box .btn a {
    display: inline-block;
    width: 100%;
    height: 100%;
    background-color: #276dfd;
    border-radius: 10px;
    font-family: 'Poppins-SemiBold';
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    text-align: center;
    line-height: 66px;
    letter-spacing: 0px;
    color: #ffffff
}

$dialog-bg-hover: #F0F2F9;
$dialog-border-color: #EEEEEE;
$primary-color: #276DFD;
$secondary-color: #6A6F80;
$font-color-dark: #233367;
$font-family-bold: "Poppins-Bold";
$font-family-semibold: "Poppins-SemiBold";

.renew-bulk {
  ::v-deep .el-dialog {
    max-width: 651px;
    border-radius: 12px;

    &__header {
      padding-top: 8%;
      padding-bottom: 5.5%;

      .el-dialog__title {
        font-size: 24px;
        font-family: $font-family-bold;
        font-weight: bold;
        color: #223265;
        line-height: 35px;
      }

      .el-dialog__headerbtn i {
        font-size: 22px;
      }
    }

    &__body {
      padding: 0;
      padding-bottom: 0;

      .renew-bulk-center {
        .ips-list {
          max-height: 410px;
          overflow-y: auto;
          padding: 0 3% 0 6%;
          box-sizing: border-box;
          margin-right: 3%;

          .ip-div {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 1.94% 4.25%;
            box-sizing: border-box;

            .ip {
              font-size: 16px;
              font-family: $font-family-semibold;
              font-weight: 600;
              color: $secondary-color;
              line-height: 25px;
            }

            i {
              color: $secondary-color;
              font-size: 15px;
              cursor: pointer;
            }

            &:hover {
              background: $dialog-bg-hover;
              border-radius: 8px;

              .ip {
                color: $font-color-dark;
              }

              i {
                color: $primary-color;
              }
            }
          }
        }
      }
    }

    &__footer {
      padding: 5.1% 6% 8.6% 6%;
      border-top: 1px solid $dialog-border-color;

      .dialog-footer {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;

        .btn-b {
          max-width: 268px;
          padding: 21px 0;
          width: 47%;
          box-sizing: border-box;
          background: $primary-color;
          border-radius: 12px;
          font-size: 18px;
          font-family: $font-family-bold;
          font-weight: bold;
          color: #FFFFFF;
        }

        .btn-w {
          max-width: 268px;
          padding: 21px 0;
          width: 47%;
          box-sizing: border-box;
          border-radius: 12px;
          border: 1px solid $primary-color;
          font-size: 18px;
          font-family: $font-family-bold;
          font-weight: bold;
          color: $primary-color;
          margin: 0;
        }
      }
    }
  }
}


.tag-bulk {
  ::v-deep .el-dialog {
    max-width: 351px;
    border-radius: 12px;

    &__header {
      padding-top: 6%;
      padding-bottom: 5.5%;

      .el-dialog__title {
        font-size: 24px;
        font-family: $font-family-bold;
        font-weight: bold;
        color: #223265;
        line-height: 35px;
      }

      .el-dialog__headerbtn i {
        font-size: 22px;
      }
    }

    &__body {
      padding: 0;
      padding-bottom: 0;

      .tag-bulk-center {
        max-height: 410px;
        overflow-y: auto;
        padding: 0 3% 0 6%;
        box-sizing: border-box;
        margin-right: 3%;

        .form-line {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 5% 4.25%;
          box-sizing: border-box;

          .tag {
            font-size: 16px;
            font-family: $font-family-semibold;
            font-weight: 600;
            color: $secondary-color;
            line-height: 25px;
          }
        }
      }
    }

    &__footer {
      padding: 5.1% 6% 6% 6%;
      border-top: 1px solid $dialog-border-color;

      .dialog-footer {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;

        .btn-b {
          max-width: 268px;
          padding: 12px 0;
          width: 47%;
          box-sizing: border-box;
          background: $primary-color;
          border-radius: 12px;
          font-size: 18px;
          font-family: $font-family-bold;
          font-weight: bold;
          color: #FFFFFF;
        }

        .btn-w {
          max-width: 268px;
          padding: 12px 0;
          width: 47%;
          box-sizing: border-box;
          border-radius: 12px;
          border: 1px solid $primary-color;
          font-size: 18px;
          font-family: $font-family-bold;
          font-weight: bold;
          color: $primary-color;
          margin: 0;
        }
      }
    }
  }
}

::v-deep .disabled-renew-row {
  background-color: $table-disabled-bg !important;

  .cell {
    color: $table-disabled-text !important;
  }

  // 只禁用续费按钮，复制按钮保留品牌色
  .el-button.operate {
    &:not(:first-child) {
      display: none;
    }
    &:first-child {
      color: $button-bg-color-primary !important;
      opacity: 0.6;
      &:hover {
        opacity: 0.85;
      }
    }
  }
}

.ip-input-group {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: $background-color;
  border-radius: $border-radius;
  overflow: hidden;

  .el-input {
    flex: 1;
    height: 100%;

    ::v-deep .el-input__inner {
      border: none;
      background-color: transparent;
      font-family: $font-family;
      font-size: $font-size;
      color: $text-color;
      border-radius: 0;

      &:disabled {
        background-color: rgba(0, 0, 0, 0.1);
        color: $placeholder-color;
        cursor: not-allowed;
      }

      &::placeholder {
        font-family: $font-family;
        font-size: $font-size;
        color: $placeholder-color;
      }
    }

    ::v-deep .el-input__suffix {
      .clear-import-btn {
        cursor: pointer;
        color: $secondary-color;
        font-size: 14px;
        transition: color 0.3s ease;

        &:hover {
          color: $primary-color;
        }
      }
    }
  }

  .import-btn {
    height: 100%;
    border: none;
    border-radius: 0;
    background-color: $button-bg-color-secondary;
    color: $button-bg-color-primary;
    font-family: $font-family;
    font-size: $font-size;
    padding: 0 16px;
    white-space: nowrap;
    max-width: 80px;

    &:disabled {
      background-color: rgba(39, 109, 253, 0.3);
      color: rgba(255, 255, 255, 0.6);
      cursor: not-allowed;
    }

    &:not(:disabled):hover {
      background-color: darken($button-bg-color-secondary, 10%);
    }
  }
}

</style>